"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _draftJsButtons = require("draft-js-buttons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ListPicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ListPicker, _Component);

  function ListPicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onWindowClick", function () {
      return (// Call `onOverrideContent` again with `undefined`
        // so the toolbar can show its regular content again.
        _this.props.onOverrideContent(undefined)
      );
    });

    return _this;
  }

  var _proto = ListPicker.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      window.addEventListener('click', _this2.onWindowClick);
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  };

  _proto.render = function render() {
    var _this3 = this;

    var buttons = [_draftJsButtons.UnorderedListButton, _draftJsButtons.OrderedListButton];
    return /*#__PURE__*/_react["default"].createElement("div", null, buttons.map(function (Button, i) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line
        _react["default"].createElement(Button, _extends({
          key: i
        }, _this3.props))
      );
    }));
  };

  return ListPicker;
}(_react.Component);

var _default = ListPicker;
exports["default"] = _default;
module.exports = exports.default;